module.exports = __webpack_public_path__ + "img/5.d4615f8a.jpg";